import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IUser, UsersList } from '@core-lib/models/user.model';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthSharedService } from './auth.service';
import { UtilisateurApiService } from '@core-lib/api-client/api/utilisateur.service';
import { apiVersion } from '@core-lib/enums/api-version.enum';
import { ICarpaLight } from '@core-lib/models';

@Injectable({
	providedIn: 'root'
})
export class UserService {
	get tenantKey() {
		return this.authService.currentTenantKey;
	}

	constructor(
		private http: HttpClient,
		private authService: AuthSharedService,
		private utilisateurApiService: UtilisateurApiService
	) {}

	getUser(): Observable<IUser> {
		// TODO: Remove
		return this.http.get<IUser>(`${environment.apiUrl}/user/me`);

		// TODO: Use generated api client
		return this.utilisateurApiService.getUtilisateurCourant(apiVersion.v1).pipe(
			map(
				user =>
					<IUser>{
						id: user.id!,
						prenom: user.prenom!,
						nom: user.nom!,
						roles: user.roles!,
						permissions: user.permissions!,
						email: user.email!,
						nomContact: user.nomContact!,
						dateDebut: user.dateDebut,
						dateFin: user.dateFin,
						telephone: user.telephone!,
						tenants: user.tenants.map(
							t =>
								<ICarpaLight>{
									id: t.id,
									nom: t.nom,
									tenantKey: t.tenantKey,
									email: t.email
								}
						)
					}
			)
		);
	}

	getUsersForTenant(inclureNonActifs?: boolean): Observable<UsersList> {
		let httpParams = new HttpParams();
		httpParams = httpParams.append('pageNumber', '1').append('pageSize', '500');

		if (inclureNonActifs) {
			httpParams = httpParams.append('inclureNonActifs', 'true');
		}

		return this.http.get<UsersList>(`${environment.apiUrl}/t/${this.tenantKey}/user`, { params: httpParams }).pipe(
			map(response => {
				response.items = response.items.sort(this.compare);
				return response;
			})
		);
	}

	private compare(a: IUser, b: IUser) {
		if (a.nom + a.prenom < b.nom + b.prenom) {
			return -1;
		}
		if (a.nom + a.prenom > b.prenom) {
			return 1;
		}
		return 0;
	}
}
